import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import { purpleOutlineButtonStyle } from 'components/magic/styled'
import GetStartedButton from 'components/magic/GetStartedButton'
import colors from 'styles/colors'

const Wrapper = styled.div`
  flex: 0 0 auto;

  ${mediaQuery.tabletMax} {
    color: ${colors.white};
    padding: 0 24px 40px;
  }
`

const OutlineButton = styled.a`
  ${purpleOutlineButtonStyle};
  text-align: center;

  display: inline-block;
  color: currentColor;

  ${mediaQuery.bigTabletMin} {
    margin-left: 8px;

    &:last-child {
      margin-right: 0;
    }
  }

  ${mediaQuery.tabletMax} {
    width: 100%;
    margin-bottom: 15px;
  }
`

const GetStartedButtonStyled = styled(GetStartedButton)`
  color: ${colors.white};

  ${mediaQuery.tabletMax} {
    width: 100%;
    margin-bottom: 15px;
  }
`

const NavButtons = () => (
  <Wrapper>
    <GetStartedButtonStyled />
    <OutlineButton href={process.env.MAGIC_URL}>Log in</OutlineButton>
    <OutlineButton href="https://flipfit.app.link/GSi4Su4P51">
      Download the app
    </OutlineButton>
  </Wrapper>
)

export default NavButtons
